var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 0.083313C5.41843 0.083313 0.0830078 5.41873 0.0830078 12C0.0830078 18.5812 5.41843 23.9166 11.9997 23.9166C18.5809 23.9166 23.9163 18.5812 23.9163 12C23.9163 5.41873 18.5809 0.083313 11.9997 0.083313ZM17.165 9.98498C17.2601 9.87626 17.3325 9.74961 17.378 9.61249C17.4234 9.47538 17.441 9.33055 17.4296 9.18655C17.4183 9.04254 17.3782 8.90226 17.3119 8.77395C17.2455 8.64565 17.1542 8.53191 17.0432 8.43943C16.9322 8.34696 16.8039 8.27761 16.6657 8.23546C16.5275 8.19332 16.3823 8.17924 16.2386 8.19404C16.0949 8.20885 15.9557 8.25224 15.829 8.32167C15.7023 8.39109 15.5908 8.48515 15.501 8.59831L10.8427 14.1872L8.43226 11.7757C8.22794 11.5784 7.95429 11.4692 7.67024 11.4717C7.38619 11.4741 7.11448 11.5881 6.91362 11.7889C6.71276 11.9898 6.59883 12.2615 6.59636 12.5455C6.59389 12.8296 6.70309 13.1032 6.90042 13.3076L10.1504 16.5576C10.2569 16.6639 10.3843 16.747 10.5246 16.8014C10.6649 16.8558 10.815 16.8803 10.9654 16.8735C11.1157 16.8667 11.263 16.8286 11.3978 16.7617C11.5326 16.6948 11.652 16.6006 11.7483 16.485L17.165 9.98498Z",
    fill: "#62718A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/gray_check.5f0d4e55.svg";
export { ForwardRef as ReactComponent };